import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../Constant";
export const NudgeSlice = createSlice({
 name: "nudge",
 initialState: {
  error: false,

  nudgeMail: "",
  isNudgeLoaded: false,
 },
 reducers: {
  setNudgeMail: (state, { payload }) => {
   state.nudgeMail = payload;
   state.isNudgeLoaded = true;
  },

  setError: (state) => {
   state.error = true;
  },

  setNudgeLoad: (state) => {
   state.isNudgeLoaded = false;
  },
 },
});

// Action creators are generated for each case reducer function
export const { setError, setNudgeMail, setNudgeLoad } = NudgeSlice.actions;

export default NudgeSlice.reducer;

export function handleGenerateNudge(values) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/nudge/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setNudgeMail(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
export function handleNudgeLoading() {
 return (dispatch) => {
  dispatch(setNudgeLoad());
 };
}
